// import { WebApiURL } from "../../../Constants/Constants";
// import { useEffect, useState } from "react";
// import dayjs from "dayjs";
// import axios from "axios";

// function EventCalendar() {
//     const [month, setMonth] = useState(dayjs().month()); // 0-indexed
//     const [year, setYear] = useState(dayjs().year());
//     const [events, setEvents] = useState([]);
//     useEffect(() => {
//     axios.get(`${WebApiURL}Events/All`).then((res) => {
//         setEvents(res.data);
//     });
//     }, []);

//     const daysInMonth = dayjs(`${year}-${month + 1}-01`).daysInMonth();
//     const dates = Array.from({ length: daysInMonth }, (_, i) => i + 1);
//     const getEventForDate = (day) => {
//     const dateStr = dayjs(`${year}-${month + 1}-${day}`)
//     .format("YYYY-MM-DD");
//     return events.find((ev) =>
//         dayjs(ev.eventDate).format("YYYY-MM-DD") === dateStr
//     );
//     };
//   return (
//     <>
//     <div className="service-title text-green-38B652 font-700 mb-3">EVENT  <span className="text-orange-ef3e33 font-400">CALENDAR</span></div>
//               <div className="service-box mb-5 mb-sm-4">
//                 The South African Maritime Safety Authority (“SAMSA”) was established in  terms of SAMSA Act, 1998<br/>
//                 (“the Act”) as a juristic person.<br/>
// 	Its objectives are―</div>

//               <div className="row g-3 g-sm-4">
//                 <div className="col-lg-10">

//                   <div className="row g-3 g-sm-4 g-md-5">
//                     <div className="col-12">
//                         <div className=" w-100">
//                         <div className="calendarWrap">
//                         <div className="row g-3">
//                             <div className="col-auto">
//                             <i
//                                 className="bi bi-chevron-left"
//                                 onClick={() => setMonth(month === 0 ? 11 : month - 1)}
//                                 style={{ cursor: "pointer" }}
//                             ></i>{" "}
//                             {dayjs().month(month).format("MMMM")}{" "}
//                             <i
//                                 className="bi bi-chevron-right"
//                                 onClick={() => setMonth(month === 11 ? 0 : month + 1)}
//                                 style={{ cursor: "pointer" }}
//                             ></i>
//                             </div>
//                             <div className="col-auto">
//                             <i
//                                 className="bi bi-chevron-left"
//                                 onClick={() => setYear(year - 1)}
//                                 style={{ cursor: "pointer" }}
//                             ></i>{" "}
//                             {year}{" "}
//                             <i
//                                 className="bi bi-chevron-right"
//                                 onClick={() => setYear(year + 1)}
//                                 style={{ cursor: "pointer" }}
//                             ></i>
//                             </div>
//                             <div className="col-12">
//                             <div className="calendarBox bg-gray-d9 p-3">
//                                 <div className="row row-cols-3 row-cols-sm-6 g-3">
//                                 {dates.map((day) => {
//                                     const event = getEventForDate(day);
//                                     return (
//                                     <div className="col" key={day}>
//                                         <div className={`date ${event ? "event" : ""}`}>
//                                         <div className="number">{day}</div>
//                                         <div className="detail">{event?.title || ""}</div>
//                                         </div>
//                                     </div>
//                                     );
//                                 })}
//                                 </div>
//                             </div>
//                             </div>
//                         </div>
//                         </div>                     
//                             {/* <h4 className="title text-green-38B652 mt-3 mb-2 font-17 font-600 text-wrap">Min 02-25 All Samsa Personnel, Ship Agents, Port Authorities, Ship Owners, Ship Managers, Seafarers And Other Interested ....</h4>
//                             <p className="font-17 text-primary-color">Ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo  consequat. Duis aute irure dolor in reprehenderit in voluptate velit  esse cillum dolore eu ,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co</p>                            
//                          */}
//                         </div>
//                     </div>
//                     <div className="col-12">
//                         {/* <div className=" w-100">
//                             <div className="quote-title mb-3 text-green-38B652 d-flex">
//                                 <div className="flex-1">
//                                     Access to Seafaring Careers <span className="font-600">Survey : 2025</span>
//                                 </div>
//                                 <i className="icon-quote"></i>
//                             </div>
//                             <div className="row g-3 align-items-center mb-4">
//                                 <div className="col-auto">
//                                     <button className="btn-green-38B652 rounded-2 font-700">Take it now</button>
//                                 </div>
//                                 <div className="col-auto text-orange-ef3e33">Recommended By SAMSA</div>                           
//                             </div>                           
//                         </div> */}
//                     </div>
//                   </div>              
//                 </div>
//                 {/* <div className="col-lg-4">
//                   <div className="row g-3 g-sm-4 g-md-4">
//                         <div className="col-12">
//                             <div className="bg-gray-d9 p-4">
//                                 <h3 className="sideline-title font-23 font-700 mb-3">Search here</h3>
//                                 <div className="input-group"><input type="text" className="form-control height-45 rounded-0 font-17" placeholder="search here....." />  </div>
//                             </div>
//                         </div>
//                         <div className="col-12">
//                             <div className="bg-gray-d9 p-4">
//                                 <h3 className="sideline-title font-23 font-700 mb-3">Recent News</h3>
//                                 <div className="row g-3 g-sm-4">
//                                     <div className="col-md-12 col-sm-6">
//                                         <div className="row g-3">
//                                             <div className="col-auto">
//                                                 <div className="bg-primary-green ratio-80" ></div>
//                                             </div>
//                                             <div className="col text-primary-color">
//                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
//                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-12 col-sm-6">
//                                         <div className="row g-3">
//                                             <div className="col-auto">
//                                                 <div className="bg-primary-green ratio-80" ></div>
//                                             </div>
//                                             <div className="col text-primary-color">
//                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
//                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-12 col-sm-6">
//                                         <div className="row g-3">
//                                             <div className="col-auto">
//                                                 <div className="bg-primary-green ratio-80" ></div>
//                                             </div>
//                                             <div className="col text-primary-color">
//                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
//                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-12 col-sm-6">
//                                         <div className="row g-3">
//                                             <div className="col-auto">
//                                                 <div className="bg-primary-green ratio-80" ></div>
//                                             </div>
//                                             <div className="col text-primary-color">
//                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
//                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
//                                             </div>
//                                         </div>
//                                     </div>


//                                 </div>
//                             </div>
//                         </div>
//                   </div>
//                 </div> */}
//               </div>
//     </>
//   )
// }

// export default EventCalendar;


// DaySeafarer changesing to EventCalendar

import newsImg1 from "./../../../assets/images/day-seafarer-img.png";
import newsImg2 from "./../../../assets/images/DayOfSeafarer.jpeg";

function EventCalendar() {

    return (
        <>
            <div className="service-title text-green-38B652 font-700 mb-3">EVENTS</div>
            {/* <div className="service-box mb-5 mb-sm-4">
                The South African Maritime Safety Authority (“SAMSA”) was established in  terms of SAMSA Act, 1998<br/>
                (“the Act”) as a juristic person.<br/>
    Its objectives are―</div> */}

            {/* <div className=" w-100 mb-4">
                <div className="card-img mb-4 position-relative">
                    <img src={newsImg1} alt="Profile" className="img-fluid w-100" />
                </div>

                <h4 className="title text-primary-color mb-3 font-17 font-600 text-wrap">THE DEPUTY MINISTER OF TRANSPORT, HONOURABLE SINDISIWE CHIKUNGA ALONGSIDE  THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY HEREBY INVITE YOU TO THE DAY OF SEAFARERS' COMMEMORATION </h4>
                <p className="font-17 text-primary-color mb-3">The theme for this year's commemoration, as endorsed by IMO is:    “Your voyage-then and now, share your journey'". The campaign for the day of the seafarer this year looks at seafarer  experiences on their voyages, what it includes and how it has evolved  over time and what remains at the heart of seafarers' reality.
                </p>
                <p className="font-17 text-primary-color">The South African Maritime Safety Authority (SAMSA) will host this year's event in Durban on Monday, 27 June 2022.</p>
            </div> */}



            <div className="row g-3 g-sm-4 g-md-5">
                <div className="col-12">
                    <div className="accordion blackTab" id="blackTab">
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#blackTabOne" aria-expanded="true" aria-controls="blackTabOne">
                                    SAMSA Celebrates “My Harassment Free Ship” on Day of the Seafarer in Cape Town
                                </button>
                            </h2>
                            <div id="blackTabOne" className="accordion-collapse collapse show" data-bs-parent="#blackTab">
                                <div className="accordion-body">
                                    <div className="row g-3 g-sm-4 g-md-5">
                                        {/* <div className="col-lg-5 col-md-6">
                      <div className="row g-2">
                       <div className="col-md-12 col-sm-6">
                          <div className="font-700 text-primary-color mb-0">DATE</div>
                          <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                        </div>
                        
                        <div className="col-md-12 col-sm-6">
                          <div className="font-700 text-primary-color mb-0">VENUE</div>
                          <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                        </div>

                        <div className="col-md-12 col-sm-6">
                          <div className="font-700 text-primary-color mb-0">TIME</div>
                          <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                        </div>

                        <div className="col-md-12 col-sm-6">
                          <div className="font-700 text-primary-color mb-0">RSVP</div>
                          <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                        </div>
                        
                      </div>
                    </div> */}
                                        {/* <div className="col-lg-7 col-md-6">
                        <div className="row g-3">
                            <div className="col-auto">
                                <div className="bg-primary-green ratio-80" ></div>
                            </div>
                            <div className="col text-primary-color">
                                <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">RSVP</span></h4>
                                <p className="font-17 mb-0 lineHeight-20 mb-4" >Wreck-removal-of-<br/>grounded.</p>  

                                <form className="row g-3">
                                  <div className="col-12"><input class="form-control height-45 rounded-0 font-17" placeholder="" type="text"/></div>
                                  <div className="col-12"><input class="form-control height-45 rounded-0 font-17" placeholder="" type="text"/></div>
                                  <div className="col-12"><input class="form-control height-45 rounded-0 font-17" placeholder="" type="text"/></div>
                                  <div className="col-12"><button className="btn-primary-green px-3 py-2 text-uppercase">Submit</button></div>
                                </form>  
                            </div>
                        </div>
                        
                    </div> */}

                                        <div className="col-12">
                                            <div className=" w-100 mb-4">
                                                <div className="card-img mb-4 position-relative">
                                                    <img src={newsImg2} alt="Profile" className="img-fluid w-100" />
                                                </div>

                                                <h4 className="title text-primary-color mb-3 font-17 font-600 text-wrap">SAMSA Celebrates “My Harassment Free Ship” on Day of the Seafarer in Cape Town </h4>
                                                <p className="font-17 text-primary-color mb-3">Every day, thousands of seafarers brave the oceans to keep global trade moving ensuring that goods, fuel, food, and vital supplies reach every corner of the world. Their tireless, often unseen contribution is the centre of the global economy. On Wednesday, 25 June 2025, the South African Maritime Safety Authority (SAMSA) honoured these maritime heroes by hosting the annual and internationally acclaimed Day of the Seafarer in Cape Town, V&A Waterfront, Makers Landing.</p>
                                                <p className="font-17 text-primary-color mb-3">This year’s global theme by the International Maritime Organisation (IMO), “My Harassment Free Ship,” put the spotlight on creating safe, respectful, and inclusive environments at sea, free from harassment and abuse. The event brought together seafarers, cadets, industry stakeholders, maritime institutions, high school pupils, and government representatives in a show of solidarity and shared commitment to improving life onboard.</p>
                                                <p className="font-17 text-primary-color mb-3">As part of its efforts to tackle harassment in the maritime sector, SAMSA, through its Occupational Health and Safety (OHS) office, has been actively driving gender-based violence (GBV) campaigns. These include training workshops, awareness drives, and the promotion of clear, confidential reporting channels for seafarers across South African waters.</p>
                                                <p className="font-17 text-primary-color mb-3">Nationwide outreach efforts include distributing educational materials at ports and engaging seafarers directly. The latest one was in early December 2024 for a walk-about in Durban and Cape Town ports, spearheaded by Mr. Sibusiso Rantsoabe Manager: OHS & Maritime Welfare. SAMSA also collaborates with international bodies like the International Maritime Organization (IMO) and the International Labour Organization (ILO) to influence global policies protecting South African seafarers abroad.</p>
                                                <p className="font-17 text-primary-color mb-3">A key highlight of the event was a panel discussion that tackled crucial issues such as mental and emotional wellness at sea, and the importance of psychological support for seafarers working in isolated and high-pressure environments. In addition, various exhibitors from the maritime sector and other organisations were present, engaging with learners and attendees about the exciting opportunities in the maritime sector.</p>
                                                {/* <p className="font-17 text-primary-color mb-3"></p>

                                                <p className="font-17 text-primary-color"></p> */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#blackTabTwo" aria-expanded="false" aria-controls="blackTabTwo">
                                    THE EVENT WILL TAKE PLACE AS FOLLOWINGS
                                </button>
                            </h2>
                            <div id="blackTabTwo" className="accordion-collapse collapse" data-bs-parent="#blackTab">
                                <div className="accordion-body">
                                    <div className="row g-3 g-sm-4 g-md-5">
                                        <div className="col-lg-5 col-md-6">
                                            <div className="row g-2">
                                                <div className="col-md-12 col-sm-6">
                                                    <div className="font-700 text-primary-color mb-0">DATE</div>
                                                    <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                                                </div>

                                                <div className="col-md-12 col-sm-6">
                                                    <div className="font-700 text-primary-color mb-0">VENUE</div>
                                                    <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                                                </div>

                                                <div className="col-md-12 col-sm-6">
                                                    <div className="font-700 text-primary-color mb-0">TIME</div>
                                                    <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                                                </div>

                                                <div className="col-md-12 col-sm-6">
                                                    <div className="font-700 text-primary-color mb-0">RSVP</div>
                                                    <div className="text-primary-color font-17">2019/08/05  10.35 AM</div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-6">
                                            <div className="row g-3">
                                                <div className="col-auto">
                                                    <div className="bg-primary-green ratio-80" ></div>
                                                </div>
                                                <div className="col text-primary-color">
                                                    <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">RSVP</span></h4>
                                                    <p className="font-17 mb-0 lineHeight-20 mb-4" >Wreck-removal-of-<br />grounded.</p>

                                                    <form className="row g-3">
                                                        <div className="col-12"><input class="form-control height-45 rounded-0 font-17" placeholder="" type="text" /></div>
                                                        <div className="col-12"><input class="form-control height-45 rounded-0 font-17" placeholder="" type="text" /></div>
                                                        <div className="col-12"><input class="form-control height-45 rounded-0 font-17" placeholder="" type="text" /></div>
                                                        <div className="col-12"><button className="btn-primary-green px-3 py-2 text-uppercase">Submit</button></div>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>



            </div>
        </>
    );
}

export default EventCalendar;